// Configuration for different slide types
export const SLIDE_CONFIGS = {
  'ny-pub-upsell': {
    id: 'ny_publication',
    component: 'ai',
    jurisdictionRequired: 'NY',
    aiConfig: {
      promptSlug: 'article-new-york-publication',
      queryType: 'article',
      eventingProperties: {
        elementName: 'ny_publication_ai_slide',
        aiProjectName: 'ny_publication'
      },
      titleKey: 'dashboard.aiPanel.nyPublication.title',
      overlineKey: 'dashboard.aiPanel.nyPublication.overline',
      subtitleKeys: {
        corporation: 'dashboard.aiPanel.nyPublication.subtitle.corp',
        llc: 'dashboard.aiPanel.nyPublication.subtitle.llc'
      },
      errorKey: 'dashboard.aiPanel.errorGeneric',
      banner: {
        titleKey: 'dashboard.aiPanel.nyPublication.banner.title',
        descriptionKey: 'dashboard.aiPanel.nyPublication.banner.description',
        ctaTextKey: 'dashboard.aiPanel.nyPublication.banner.ctaText',
        onCtaClick: (businessEntity, handleCloseSlide, configId) => {
          const url = `/dashboard/${businessEntity?.uuid}/products/ny-publication`;
          window.location.href = url;
          handleCloseSlide(configId);
        }
      }
    }
  }
};
